import { render, staticRenderFns } from "./RichTabs.vue?vue&type=template&id=1b7f5dd0&scoped=true"
import script from "./RichTabs.vue?vue&type=script&lang=js"
export * from "./RichTabs.vue?vue&type=script&lang=js"
import style0 from "./RichTabs.vue?vue&type=style&index=0&id=1b7f5dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f5dd0",
  null
  
)

export default component.exports